module.exports = __webpack_public_path__ + "img/live.a8286194.svg";